import React, { useState } from "react";
import { Button, Modal } from "antd";

const RemoveTech = ({
  arg: { handleDeletebutton, open, setOpen, confirmLoading, setConfirmLoading },
}) => {
  const [modalText, setModalText] = useState("Content of the modal");
  const showModal = () => {
    setOpen(true);
  };

  const contentData = () => (
    <div>
      <div>
        <div className="col-lg-12 col-md-1 col-sm-12 sub2head">
          Are you sure you want to remove this technician’s account?
        </div>
      </div>
    </div>
  );

  const handleOk = () => {
    setModalText("The modal will be closed after two seconds");
  };
  const handleCancel = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="contd" onClick={showModal}>
        Remove Technician’s Account
      </div>
      <Modal
        title=""
        open={open}
        onOk={handleDeletebutton}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>{contentData()}</p>
      </Modal>
    </>
  );
};
export default RemoveTech;
